function setIsOverDisplayer(draft, actions) {
    draft.overDisplayer = actions.payload;
}
export { setIsOverDisplayer };
